import React, { useState, useEffect } from "react";

import "../style/app-cost-calculator/multi-step.scss";
import "../style/app-cost-calculator/estimate.scss";
import {
  GenerativeAIServiceTick 
} from "../../../app-constants";
import axios from "axios";

function Estimate() {
  const [projectData, setProjectData] = useState();
  const [features, setFeatures] = useState();
  const [requiredFeatures, setRequiredFeatures] = useState();
  let featureCost = 0;
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const projectIdFromUrl = queryParams.get('projectId');
    console.log("projectIdFromUrl", projectIdFromUrl);

    if (!projectIdFromUrl) {
      console.log("No projectId found, redirecting...");
      window.location.href = `/app-cost-calculator`;
      return;
    }

    const fetchProjectData = async (projectId) => {
      try {
        const response = await axios.get(`https://api.tekrevol.com/api/project/${projectId}`);
        // console.log("response.data.data", response.data.data);
        console.log("response.data.data.features", response.data.data.features);
        setProjectData(response.data.data.project);
        setFeatures(response.data.data.features)
        setRequiredFeatures(response.data.data.required_features)
        console.log("projectData", projectData)
      } catch (error) {
        window.location.href = `/app-cost-calculator`;
      }
    };
    fetchProjectData(projectIdFromUrl);
  }, []);

  const formattedPrice = (value) => {
    if (typeof value !== "number") {
      return "0.00";
    }
    return value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  return (
      <>
        <section id="estimation" className="mt-100">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 m-auto estimation-div">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-8">
                    <div className="point-number">{/* <span>Cost</span> */}</div>
                    <h1>Your estimated cost</h1>
                  </div>
                  <div className="col-12 col-sm-12 col-md-4">
                    <div className="price-total"> ${formattedPrice(projectData?.estimated_price)}</div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12">
                    <p>
                      The actual cost of your project may vary depending on its
                      detailed scope.
                    </p>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 est-project-name">
                    <h2>{capitalizeFirstLetter(projectData?.project_name)}</h2>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 core-sec">
                    <div className="core-btn">core elements</div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 tabel-sec">
                    <table className="table">
                      <thead>
                      <tr>
                        <th scope="col" align="left">
                          Elements
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td scope="row">Application Type: {projectData?.project_type?.name}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 core-sec">
                    <div className="core-btn">Selected Features</div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 tabel-sec">
                    <table className="table">
                      <thead>
                      <tr>
                        <th scope="col" align="left" width="400px">
                          Features
                        </th>
                        <th scope="col" className="text-center" width="200px">
                          Price
                        </th>
                        <th scope="col" className="text-center" width="200px">
                          Design
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      {features?.map((ans, index) => {
                        if (ans.price > 0) {
                          featureCost += ans.price; // Accumulate the feature cost
                          return ( // Ensure to return the JSX
                              <tr key={index}>
                                <td scope="row" width="400px">
                                  {ans.feature}
                                  {ans.is_boolean === 0 && ` (${ans.answer})`}
                                </td>
                                <td align="center" width="200px">
                                  ${formattedPrice(ans.price)}
                                </td>
                                <td align="center" width="200px">
                                  {GenerativeAIServiceTick}
                                </td>
                              </tr>
                          );
                        }
                        return null;
                      })}
                      </tbody>
                    </table>
                    <div className="btn-table">
                      <div className="newbbb">subtotal: ${featureCost.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 core-sec">
                    <div className="core-btn">App Essentials</div>
                    <p>
                      Building blocks for successful ideation, development,
                      quality and delivery of your application.
                    </p>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 tabel-sec">
                    <table className="table">
                      <thead>
                      <tr>
                        <th scope="col" align="left" width="400px">
                          Features
                        </th>
                        <th scope="col" className="text-center" width="200px">
                          Price
                        </th>
                        <th scope="col" className="text-center" width="200px">
                          Design
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      {requiredFeatures?.map((feature, index) => (
                          <tr key={index}>
                            <td scope="row" width="300px">
                              {feature.name}
                            </td>
                            <td align="center" width="200px">
                              ${formattedPrice(feature.price)}
                            </td>
                            <td align="center" width="200px">
                              {GenerativeAIServiceTick}
                            </td>
                          </tr>
                      ))}
                      </tbody>
                    </table>
                    <div className="btn-table">
                      <div
                          className="newbbb"
                          onClick={() =>
                              window.videoask.loadModal(
                                  "https://www.videoask.com/fv0eq81z8"
                              )
                          }
                      >
                        Book an initial Call
                      </div>
                      <div className="newbbb">subtotal: ${formattedPrice(projectData?.required_feature_cost)}</div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 estimation-footer">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="last-para">Estimated cost</div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6">
                        <div className="last-price">${formattedPrice(projectData?.estimated_price)}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="btn-table"></div>
              </div>
            </div>
          </div>
        </section>
      </>
  );
}

export default Estimate;
